module.exports = __webpack_public_path__ + "static/img/11.b457f00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/familybuilding/11.jpg
// module id = PLWv
// module chunks = 0